module.exports = __webpack_public_path__ + "./kit/docs/img/big-icon-error_list.3cc633c89be0b5a68a52370f1b0a7983.svg";